import {View} from 'react-native';
import {useAppDispatch, useAppSelector} from '../../store/hooks';
import {Text} from 'react-native-paper';

export function PremiumDialogBody() {
  const purchasePrice = useAppSelector(
    state => state.auction.purchasePrice,
  );
  return (
    <View style={{width: '100%', height: 'auto'}}>
      <Text>To enable this service you will pay {purchasePrice}</Text>
    </View>
  );
}
